import { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

function Trips() {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        // Try ordering by createdAt
        let q = query(collection(db, 'trips'), orderBy('createdAt', 'desc'), limit(50));
        let snapshot = await getDocs(q);
        

        const tripsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTrips(tripsData);
      } catch (error) {
        console.error("Error fetching trips:", error);
        // Fallback: try without ordering
        try {
          const q = query(collection(db, 'trips'), limit(50));
          const snapshot = await getDocs(q);
          const tripsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setTrips(tripsData);
        } catch (e) {
          console.error("Fallback also failed:", e);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTrips();
  }, []);

  const getStatusBadge = (status) => {
    const badges = {
      completed: <span className="badge badge-success">Completado</span>,
      searching: <span className="badge badge-warning">Buscando</span>,
      negotiating: <span className="badge badge-warning">Negociando</span>,
      driver_assigned: <span className="badge badge-info">Asignado</span>,
      driver_on_the_way: <span className="badge badge-info">En Camino</span>,
      in_progress: <span className="badge badge-info">En Curso</span>,
      in_trip: <span className="badge badge-info">En Viaje</span>,
      cancelled: <span className="badge badge-danger">Cancelado</span>,
      no_drivers: <span className="badge badge-danger">Sin Conductor</span>,
    };
    return badges[status] || <span className="badge">{status}</span>;
  };

  const getTimestamp = (trip) => {
    const ts = trip.createdAt;
    if (!ts) return 'N/A';
    try {
      return new Date(ts.toDate()).toLocaleString();
    } catch {
      return 'N/A';
    }
  };

  if (loading) {
    return <div className="skeleton-card" style={{height:'400px'}} />;
  }

  return (
    <div className="animate-fade-in">
      <div className="page-header">
        <div>
          <h2 className="page-title">Historial de Viajes</h2>
          <p className="page-subtitle">Últimos 50 viajes registrados en la plataforma</p>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Fecha y Hora</th>
                <th>Pasajero</th>
                <th>Conductor</th>
                <th>Estado</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>Tarifa</th>
              </tr>
            </thead>
            <tbody>
              {trips.length > 0 ? trips.map((trip) => (
                <tr key={trip.id}>
                  <td className="mono-text">{trip.id.slice(0,8)}</td>
                  <td className="text-sm">{getTimestamp(trip)}</td>
                  <td className="mono-text" title={trip.passengerId}>
                    {trip.passengerName || (trip.passengerId?.slice(0,6) + '...') || '-'}
                  </td>
                  <td className="mono-text" title={trip.driverId}>
                    {trip.driverName || (trip.driverId ? trip.driverId.slice(0,6) + '...' : '-')}
                  </td>
                  <td>{getStatusBadge(trip.status)}</td>
                  <td className="truncate-cell" title={trip.pickupAddress}>{trip.pickupAddress || 'GPS'}</td>
                  <td className="truncate-cell" title={trip.destinationAddress}>{trip.destinationAddress || 'GPS'}</td>
                  <td className="font-bold" style={{color: 'var(--accent-green)'}}>
                    ${(trip.fareActual || trip.agreedFare || trip.proposedFare || trip.fareEstimate || 0).toFixed(2)}
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="8" className="empty-state">
                    <div className="empty-icon">🛵</div>
                    <p>No hay viajes registrados</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Trips;
